module.exports = __webpack_public_path__ + "img/bell.869b1f5f.svg";